/**
 * @mynaui/icons-react v0.3.1 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var Swatches = createReactComponent("swatches", "Swatches", [["path", { "d": "M6.5 21H18c1.657 0 3-1.398 3-3.123 0-1.308.13-2.63-1.297-3.253M7.98 20.664l10.287-4.67a3.037 3.037 0 0 0 1.436-1.37m-7.613-3.787 3.013-1.718c1.553-.886 3.5-.186 4.198 1.509l.525 1.273a3.232 3.232 0 0 1-.123 2.723m-9.821 3.718c-.5 1.912-2.42 3.047-4.287 2.535-1.867-.513-2.975-2.478-2.475-4.39L6.18 5.27c.452-1.661 2.114-2.624 3.71-2.15l1.17.348c1.615.48 2.536 2.246 2.045 3.918zM6.5 17l-.242.854", "key": "svg-0" }]]);

export { Swatches as default };
//# sourceMappingURL=Swatches.js.map
